<template>
    <div>
        <b-button class="mb-3 right" variant="primary" @click="isModalOpen=true">
            Schadenposition hinzufügen
        </b-button>

        <div class="clear"/>

        <b-modal id="cost-unit-create-modal" v-model="isModalOpen" hide-footer no-close-on-backdrop size="xl"
            title="Schadenposition hinzufügen" @hide="reset()" @show="loadForm">
            <div class="record-cost-unit-create-modal">
                <csp-desktop-info-card
                    :cols="12"
                    :form-context="formContext"
                    icon="inticon-users"
                    title="Kunde"
                    @cancel-form="reset"
                    @save="saveCostUnitFormData">
                    <csp-record-detail-cost-unit-basedata
                        :form-context="formContext"
                        :hide-for-group-options="hideForGroupOptions"
                        :record-id="recordId"/>
                </csp-desktop-info-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/record/document-upload-modal.scss';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import CostUnitBasedata from '@desktop/components/record/cost-unit/RecordCostUnitBasedata.vue';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CostUnitCreateModal',
        components: {
            'csp-record-detail-cost-unit-basedata': CostUnitBasedata,
        },
        mixins: [FormDataMixin],
        props: {
            hideForGroupOptions: {
                type: Array,
                default: null,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['created'],
        data() {
            return {
                isModalOpen: false,
            }
        },
        methods: {
            loadForm() {
                const loadFunction = () => {
                    return recordRepository.loadCostUnitCreationForm(this.recordId);
                }
                this.loadFormData(loadFunction).finally(() => {
                    this.isLoading = false;
                });
            },
            reset() {
                this.formContext.form.reset();
                this.isModalOpen = false;
            },
            saveCostUnitFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveCostUnitNew(this.recordId, postData);
                }
                this.saveFormData(formContext, saveFunction, false).then(() => {
                    this.$emit('created');
                    this.reset();
                });
            },
        },
    }
</script>
